import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import HomologBrowser from '../HomologBrowser';
import { APP_TITLE } from '../../constants/http.constants';
import { BLUE_LINK, FOOTER_BG } from '../../constants/theme.styles';

const useStyles = makeStyles(() => ({
  footer: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    textAlign: 'center',
    backgroundColor: FOOTER_BG,
    color: BLUE_LINK,
    fontSize: 12,
    padding: '15px 0 15px',
    userSelect: 'none',
  },
}));

export default function Footer() {
  const classes = useStyles();
  const [year, setYear] = useState('');

  useEffect(() => {
    const date = new Date();
    setYear(date.getFullYear());
  }, [year]);

  return (
    <div className={classes.footer}>
      <span>
        ©{year}{' '}
        <FormattedMessage id="COPY_RIGHT" values={{ app_title: APP_TITLE }} />{' '}
        <br />
        <HomologBrowser />
      </span>
    </div>
  );
}
